import { createSlice } from "@reduxjs/toolkit";
import {
  getFrasesSeleccionAplicacionThunk,
  getFraseSeleccionAplicacionByIdThunk,
  updateFraseSeleccionAplicacionThunk,
  toggleFraseSeleccionAplicacionActiveThunk,
} from "./frasesSeleccionAplicacion.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  count: 0,
  next: null,
  previous: null,
  maxPageReached: 1,
  search: "",

  selectedFrase: null,
  selectedFraseLoading: false,
  selectedFraseError: null,
  viewModalOpen: false,

  formModalOpen: false,
  formMode: "edit",
  formLoading: false,
  formError: null,

  confirmModalOpen: false,
  toggleFraseId: null,
  toggling: false,
};

const frasesSeleccionAplicacionSlice = createSlice({
  name: "frasesSeleccionAplicacion",
  initialState,
  reducers: {
    clearFrasesSeleccionAplicacionError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    clearFilters: (state) => {
      state.search = "";
      state.page = 1;
    },
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedFrase = null;
    },
    openFormModal: (state, action) => {
      state.formModalOpen = true;
      state.formMode = action.payload?.mode || "edit";
      if (action.payload?.frase) {
        state.selectedFrase = action.payload.frase;
      }
      state.formError = null;
    },
    closeFormModal: (state) => {
      state.formModalOpen = false;
      state.selectedFrase = null;
      state.formError = null;
    },
    openConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.toggleFraseId = action.payload.id;
    },
    closeConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.toggleFraseId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getFrasesSeleccionAplicacionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrasesSeleccionAplicacionThunk.fulfilled, (state, action) => {
        const { results, count, next, previous } = action.payload;
        state.loading = false;
        state.list = results;
        state.count = count;
        state.next = next;
        state.previous = previous;
        state.maxPageReached = Math.max(state.maxPageReached, state.page);
      })
      .addCase(getFrasesSeleccionAplicacionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getFraseSeleccionAplicacionByIdThunk.pending, (state) => {
        state.selectedFraseLoading = true;
        state.selectedFraseError = null;
      })
      .addCase(
        getFraseSeleccionAplicacionByIdThunk.fulfilled,
        (state, action) => {
          state.selectedFraseLoading = false;
          state.selectedFrase = action.payload;
        },
      )
      .addCase(
        getFraseSeleccionAplicacionByIdThunk.rejected,
        (state, action) => {
          state.selectedFraseLoading = false;
          state.selectedFraseError = action.payload;
        },
      )

      // UPDATE
      .addCase(updateFraseSeleccionAplicacionThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(
        updateFraseSeleccionAplicacionThunk.fulfilled,
        (state, action) => {
          state.formLoading = false;
          const index = state.list.findIndex((f) => f.id === action.payload.id);
          if (index !== -1) {
            state.list[index] = action.payload;
          }
          state.formModalOpen = false;
        },
      )
      .addCase(
        updateFraseSeleccionAplicacionThunk.rejected,
        (state, action) => {
          state.formLoading = false;
          state.formError = action.payload;
        },
      )

      // TOGGLE ACTIVE
      .addCase(toggleFraseSeleccionAplicacionActiveThunk.pending, (state) => {
        state.toggling = true;
        // Optimistic update: cambia el estado visualmente de inmediato
        const index = state.list.findIndex((f) => f.id === state.toggleFraseId);
        if (index !== -1) {
          state.list[index] = {
            ...state.list[index],
            is_active: !state.list[index].is_active,
          };
        }
      })
      .addCase(
        toggleFraseSeleccionAplicacionActiveThunk.fulfilled,
        (state, action) => {
          state.toggling = false;
          state.confirmModalOpen = false;
          // Reemplaza con la respuesta real del servidor
          const index = state.list.findIndex((f) => f.id === action.payload.id);
          if (index !== -1) {
            state.list[index] = action.payload;
          }
        },
      )
      .addCase(
        toggleFraseSeleccionAplicacionActiveThunk.rejected,
        (state, action) => {
          state.toggling = false;
          state.error = action.payload;
          // Revertir el optimistic update si falló
          const index = state.list.findIndex(
            (f) => f.id === state.toggleFraseId,
          );
          if (index !== -1) {
            state.list[index] = {
              ...state.list[index],
              is_active: !state.list[index].is_active,
            };
          }
        },
      );
  },
});

export const {
  clearFrasesSeleccionAplicacionError,
  setPage,
  setSearch,
  clearFilters,
  openViewModal,
  closeViewModal,
  openFormModal,
  closeFormModal,
  openConfirmToggle,
  closeConfirmToggle,
} = frasesSeleccionAplicacionSlice.actions;

export default frasesSeleccionAplicacionSlice.reducer;
